export const themeKey = "_thm"